import { enqueueSnackbar } from 'notistack';
import React, { createContext, useContext, useState, ReactNode, useEffect, useMemo, useCallback } from 'react';
import { NavigateFunction } from 'react-router-dom';
import axios from 'axios';

type UserRole = null | string;
interface AuthenticatedContextType {
  isAuthenticated: boolean;
  userRole: UserRole;
  loginRoute: (role: UserRole, navigate: NavigateFunction) => void;
  logout: (navigate: NavigateFunction) => void;
  getUserById: (accessToken: any) => void;
}
const AuthenticatedContext = createContext<AuthenticatedContextType | undefined>(undefined);
interface AuthenticatedProviderProps {
  children: ReactNode;
}
export const AuthenticatedProvider: React.FC<AuthenticatedProviderProps> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState<UserRole>(null);
  const userRoleName = localStorage.getItem('roleName') ?? '';

  const loginRoute = useCallback(async (role: UserRole, navigate: NavigateFunction) => {
    console.log(role);
    setIsAuthenticated(true);
    setUserRole(role);
    navigate('/dashboard');
  }, []);

  const getUserById = useCallback(async (accessToken: any) => {
    console.log(accessToken, 'one accessToken');
    try {
      const response = await axios.get(`https://chd-cavinkare-gateway.coherent.in/master-cavinkare/user/getUserById`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      console.log(response);
      if (response?.data) {
        const res = response.data?.data;
        const currentServiceToken = localStorage.getItem('serviceToken');
        if (currentServiceToken) {
          localStorage.setItem('serviceToken', currentServiceToken);
        }
        localStorage.setItem('roleName', res?.userRole);
        localStorage.setItem('userType', res?.userRole);
        localStorage.setItem('name', res?.name);
        localStorage.setItem('userId', String(res?.id));
        localStorage.setItem('email', res?.email);
      } else {
        enqueueSnackbar('Login failed', { variant: 'error' });
      }
    } catch (error: any) {
      console.error('Login error:', error);
      enqueueSnackbar(error?.response.data.message || 'Login error occurred', {
        variant: 'error'
      });
    }
  }, []);

  const logout = useCallback((navigate: NavigateFunction) => {
    setIsAuthenticated(false);
    setUserRole(null);
    navigate('/');
    localStorage.setItem('isAuthenticated', 'false');
    enqueueSnackbar('Logout successful', { variant: 'success' });
  }, []);
  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    if (userRoleName !== null && accessToken !== null) {
      setIsAuthenticated(true);
      setUserRole(userRoleName);
    }
  }, [userRoleName]);
  return (
    <AuthenticatedContext.Provider
      value={useMemo(
        () => ({
          isAuthenticated,
          userRole,
          loginRoute,
          logout,
          getUserById
        }),
        [isAuthenticated, userRole, loginRoute, logout, getUserById] // dependencies
      )}
    >
      {children}
    </AuthenticatedContext.Provider>
  );
};
export const useAuthenticated = (): AuthenticatedContextType => {
  const context = useContext(AuthenticatedContext);
  if (!context) {
    throw new Error('useAuthenticated must be used within an AuthenticatedProvider');
  }
  return context;
};
export default AuthenticatedContext;
